/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Default autocomplete suggestion structure (id + name).
 * @export
 * @interface APIAutocompleteSuggestion
 */
export interface APIAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIAutocompleteSuggestion
     */
    name: string;
}

/**
 * Check if a given object implements the APIAutocompleteSuggestion interface.
 */
export function instanceOfAPIAutocompleteSuggestion(value: object): value is APIAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIAutocompleteSuggestionFromJSON(json: any): APIAutocompleteSuggestion {
    return APIAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function APIAutocompleteSuggestionToJSON(value?: APIAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

